<template>
  <div class="v_chat g-flex-justify-start">
    <!-- 左侧 -->
    <div class="v-chat-left g-flex-column">
      <!-- 头部 -->
      <div class="v-chat-left-head g-flex-align-center">
        <div class="v-chat-left-head-tab g-flex-align-center">
          <div class="v-chat-left-head-tab-item">
            <span>当前</span>
          </div>
        </div>
        <div class="v-chat-left-head-icon"></div>
      </div>
      <!-- tab栏 -->
      <div class="v-chat-left-tab">
        <div class="v-chat-left-tab-list g-flex-align-center">
          <span class="v-chat-left-tab-item active">我的</span>
        </div>
      </div>

      <!-- 聊天列表 -->
      <ul class="v-chat-left-list g-self-scrollbar">
        <li v-for="(item, index) in chatList" :key="index" class="v-chat-left-list-item g-flex-align-center" :class="customerActiveIndex === index ? 'v-customer-active' : ''" @click="customerItemClick(item,index)">
          <div class="v-item-left" :class="item.status === 2 ? 'lixian': 'zaixian'">
            <img :src="item.avatar" alt="" >
          </div>
          <div class="v-item-right g-flex-column">
            <div class="v-item-right-top g-flex-align-center">
              <p class="v-item-right-top-name" :title="(item.name ? item.name : '游客 #' + item.id) +' (' +item.ip_address+')'">
<!--                <span>-->
<!--                  {{item.ip_address}}-->
<!--                </span>-->
                {{item.name ? item.name : '游客 #' + item.id }}
              </p>
              <span class="v-item-right-top-time" v-if="item.history.length">{{formatDate(item.history[item.history.length -1].create_time, 'MM-dd hh:mm:ss')}}</span>
            </div>

            <div class="v-item-right-bottom g-flex-align-center" v-if="item.history.length">
              <!-- 最后一条消息信息 -->
              <div class="item-right-bottom-msg" v-show="item.history[item.history.length -1].type === 0" v-html="replaceNewline(item.history[item.history.length -1].msg)"></div>
              <div v-show="item.history[item.history.length -1].type !== 0" class="item-right-bottom-msg" >{{item.history[item.history.length -1] | filtersMsg}}</div>
              <!-- 未读消息数量 -->
              <span class="item-right-bottom-msg-num" v-show="item.unreadList.length !== 0">{{item.unreadList.length}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 右侧 -->
    <div class="v-chat-right-container g-flex-align-center g-flex-justify-center">

      <chat-middle ref="ChatMiddle" :msgList="msgList" :chatUserInfo="chatUserInfo" :chatUserId="chatUserId" v-show="chatShow" @emitChatCloseDialog="emitChatCloseDialog" @emitTransferDelete="emitTransferDelete"/>
      
      <chat-right ref="ChatRight" :chatUserInfo="chatUserInfo"  v-show="chatShow" :chatUserId="chatUserId" @emitAddblackSuccess="emitAddblackSuccess"/>

      <!-- 无会话 -->
      <div class="s-no-chat-container g-flex-column g-flex-align-center"  v-show="!chatShow">
        <div class="s-no-chat">
          <SvgIcon name="nochat"/>
        </div>
        <p>无选中对话</p>
        <span>没有需要处理的对话，休息一下吧！</span>
      </div>
    </div>
  </div>
</template>

<script>
  import ChatMiddle from '@/views/chat/ChatMiddle.vue'
  import ChatRight from '@/views/chat/ChatRight.vue'
  import {apiGetDialogList, apiGetOneDialogInfo, apiCloseDialogAdmin, getMsgById, getLastReadId} from '@/utils/api.js'
  import { formatDate } from '@/utils/index.js'
  import Bus from '@/utils/bus.js'

  export default {
    components: { ChatMiddle, ChatRight },
    data() {
      return {
        chatShow: false, //聊天界面展示

        chatList: [], //聊天列表

        chatUserId: null, //用户ID

        chatUserInfo: {}, //用户信息

        panelShow: false, //聊天窗口展示标识

        customerActiveIndex: -1, //当前选中的index
        
        msgList: [], //消息列表

        isLock:false
      }
    },
    created() {
      this.apiGetDialogListHandel()
    },
    
    mounted() {
      Bus.$on('busReceiveMsg', (data) => {
        // console.log('Chat-消息来了', data)
        const userId = data.user_id;
        const chatItem = this.chatList.find(item => item.id === userId);
        if (chatItem) {
          //改成请求获取
          this.getMsgList(chatItem)
          //this.dealWithReceiveData([data])
        } else {
          //新会话初始化
          this.newcChat(userId)
        }
      })

      Bus.$on('selectedChatUserId',()=>{
        this.restoreSelectedChat()
      })

      let entId = this.$global.adminUser.ent_id
    
      // 订阅分组
      this.$ws.joinGroup(`online_${entId}`, (data) => {
        // console.log('online', data)
        this.dealWithOnlineData(data)
      })

      this.$ws.joinGroup(`lastReadId_${entId}`, (data) => {
        const chatItem = this.chatList.find(item => item.id === data.userId);
        if(chatItem){
          chatItem.lastReadId = data.lastReadId
          const history = chatItem.history || [];
          history.forEach(item => {
            // console.log(item)
            if (item.is_read === 0 && item.send_type === 2 && item.id <= data.lastReadId) {
              //刷新为已读
              item.is_read = 1
            }
          });
        }
      })
    },

    beforeDestroy() {
      Bus.$off('busReceiveMsg')
      Bus.$off('selectedChatUserId')
      let entId = this.$global.adminUser.ent_id
      this.$ws.leaveGroup(`online_${entId}`)
    },

    filters: {
      filtersMsg(item) {
        // if(item.type === 0) return item.msg
        if(item.type === 1) return '[图片]'
        if(item.type === 2) return '[文件]'
      }
    },
    methods: {
      async newcChat(userId) {
        //新会话进行请求客户信息
        const { success, data } = await apiGetOneDialogInfo({ id: userId })
        if(!success) return
        //校验防抖（防止网络请求期间产生的重复数据）
        if (this.chatList.some(item => item.id === userId)) return;
        // console.log('新顾客信息', data)
        const chatInfo = data.data;
        const history = chatInfo.history || [];
        // 4. 处理历史消息与未读数据
        if (history.length > 0) {
          chatInfo.unreadList = [history[0]];
          chatInfo.lastId = history[0].id
          history.reverse();
        } else {
          chatInfo.lastId = 0
          chatInfo.unreadList = [];
        }
        chatInfo.finish = false;
        // 5. 更新未读计数与列表排序（使用 unshift 代替双重 reverse）
        this.updateUnreadCount(chatInfo.id, 1);
        this.chatList.unshift(chatInfo);
        // 6. 更新激活索引
        if (this.customerActiveIndex >= 0) {
          this.customerActiveIndex += 1;
        }
        this.saveChatListOrder()
      },
      async getMsgList(chatItem) {
        this.isLock=true
        // console.log(chatItem)
        const {success, data} = await getMsgById({id: chatItem.lastId || 0, user_id: chatItem.id})
        this.isLock = false
        if (!success) return
        if (!data.list || data.list.length === 0) return;
        await this.dealWithReceiveData(data.list)
      },
      async getLastReadIdData(chatItem) {
        const history = chatItem.history || [];
        //检查是都有未读消息
        const hasUnreadMyMsg = history.some(item => item.send_type === 2 && item.is_read === 0);
        if (!hasUnreadMyMsg) return;
        const {success, data} = await getLastReadId({id: chatItem.lastReadId || 0, user_id: chatItem.id})
        if (!success) return
        if (data.lastReadId <= chatItem.lastReadId) return;
        //设置未读消息为已读
        chatItem.lastReadId = data.lastReadId
        history.forEach(item => {
          if (item.is_read === 0 && item.send_type === 2 && item.id <= data.lastReadId) {
            //刷新为已读
            item.is_read = 1
          }
        });
      },
      replaceNewline(content) {
        return content.replace(/<br>/g, "");
      },
      formatDate,

      apiGetOneDialogInfo,

      // 处理websocket消息
      async dealWithReceiveData(receiveDataList) {
        if (receiveDataList.length === 0) return;
        //因为都是同一个人的消息，直接取第一条拿到 userId 即可
        const userId = receiveDataList[0].user_id;

        //找到聊天列表对应的客户聊天
        const chatItem = this.chatList.find(item => item.id === userId);
        if (!chatItem) {
          await this.newcChat(userId);
          return;
        }

        const existingIds = new Set(chatItem.history.map(msg => msg.id));
        //过滤掉重复数据
        const newMsgList = receiveDataList.filter(msg => !existingIds.has(msg.id));
        //如果过滤后发现全都是重复数据，直接安全拦截退出
        if (newMsgList.length === 0) return;
        // 批量插入新消息
        chatItem.history.push(...newMsgList);

        // 当前正在聊天的用户：由于列表通常是按时间正序（旧->新），最后一条的 ID 最大
        const latestMsg = newMsgList[newMsgList.length - 1];
        if (latestMsg.id > (chatItem.lastId || 0)) {
          chatItem.lastId = latestMsg.id;
        }

        // 判断是否为当前正在聊天的用户
        if (userId !== this.chatUserId) {
          // 非当前聊天用户：批量推进未读列表
          chatItem.unreadList.push(...newMsgList);
          this.updateUnreadCount(userId, chatItem.unreadList.length);
        } else {
          this.scrollToBottom();
        }
      },

      // 处理websocket 离线在线消息
      dealWithOnlineData(receiveOnline) {
        // status  1  在线
        // status  2  隐身
        // status  0  断开连接 删除
        let obj = this.chatList.find(item => {
          return item.id === receiveOnline.id
        })
        // console.log(obj)
        if(obj) {
          if(receiveOnline.status === 0) {
            let index = this.chatList.indexOf(obj)
            // 清除该用户的未读数量
            this.updateUnreadCount(obj.id, 0)
            this.chatList.splice(index, 1)
            // 保存列表顺序
            this.saveChatListOrder()
            this.resetData()
          }else {
            let index = this.chatList.indexOf(obj)
            this.$set(this.chatList[index], 'status', receiveOnline.status)
          }
        }
      },

      // 获取聊天列表
      async apiGetDialogListHandel() {
        const { success, data } = await apiGetDialogList()
        if(!success) return
        // 获取保存的未读消息数量
        const savedUnreadMap = this.getUnreadMap()
        // 获取保存的列表顺序
        const savedOrder = this.getChatListOrder()

        //批量处理列表数据
        this.chatList = data.list.map(item => {
          item.finish = false //是否加载完毕
          if (item.history.length > 0) {
            item.lastId = item.history[0].id;
          } else {
            item.lastId = 0;
          }
          item.history.reverse()
          // 恢复未读消息状态
          const unreadCount = savedUnreadMap[item.id] || 0
          if (unreadCount > 0 && item.history.length > 0) {
            // 从历史消息末尾取出未读消息
            item.unreadList = item.history.slice(-unreadCount)
          } else {
            item.unreadList = []
          }
          return item
        })

        // 恢复列表顺序
        if (savedOrder.length > 0) {
          const orderMap = new Map(savedOrder.map((id, index) => [id, index]));
          this.chatList.sort((a, b) => {
            // 从 Map 中直接获取索引，找不到则设为 -1
            const indexA = orderMap.has(a.id) ? orderMap.get(a.id) : -1;
            const indexB = orderMap.has(b.id) ? orderMap.get(b.id) : -1;

            // 如果是新会话（不在保存的顺序中），放到最前面
            if (indexA === -1 && indexB !== -1) return -1;
            if (indexB === -1 && indexA !== -1) return 1;
            // 两个都是新会话，保持原有相对顺序
            if (indexA === -1 && indexB === -1) return 0;

            return indexA - indexB;
          });
          // //旧的算法逻辑
          // this.chatList.sort((a, b) => {
          //   const indexA = savedOrder.indexOf(a.id)
          //   const indexB = savedOrder.indexOf(b.id)
          //   // 如果是新会话（不在保存的顺序中），放到最前面
          //   if (indexA === -1) return -1
          //   if (indexB === -1) return 1
          //   return indexA - indexB
          // })
        } else {
          // 没有保存的顺序，使用默认顺序（反转，最新的在最前面）
          this.chatList.reverse()
        }
        // console.log('chatList', this.chatList)

        // 保存当前顺序
        this.saveChatListOrder()

        // 恢复上次选中的会话
        this.restoreSelectedChat()
      },

      // 恢复选中的会话
      restoreSelectedChat() {
        const savedChatUserId = sessionStorage.getItem('selectedChatUserId')
        if (!savedChatUserId) return;
        const userId = parseInt(savedChatUserId)
        const chatItem = this.chatList.find(item => item.id === userId);
        if (chatItem) {
          //判断当前是不是在同一个聊天框
          if (chatItem.id !== this.chatUserId) {
            const index = this.chatList.indexOf(chatItem);
            this.customerItemClick(chatItem, index);
          }else{
            // console.log('在同一个聊天框')
            this.scrollToBottom();
          }
        } else {
          // 如果列表里找不到该会话，说明该会话已被删除或失效，及时清除缓存
          sessionStorage.removeItem('selectedChatUserId');
        }
      },

      // 获取未读消息映射
      getUnreadMap() {
        const saved = sessionStorage.getItem('chatUnreadMap')
        return saved ? JSON.parse(saved) : {}
      },

      // 保存未读消息映射
      saveUnreadMap(map) {
        sessionStorage.setItem('chatUnreadMap', JSON.stringify(map))
      },

      // 更新某个用户的未读数量
      updateUnreadCount(userId, count) {
        const map = this.getUnreadMap()
        if (count > 0) {
          map[userId] = count
        } else {
          delete map[userId]
        }
        this.saveUnreadMap(map)
      },

      // 获取聊天列表顺序
      getChatListOrder() {
        const saved = sessionStorage.getItem('chatListOrder')
        return saved ? JSON.parse(saved) : []
      },

      // 保存聊天列表顺序
      saveChatListOrder() {
        const order = this.chatList.map(item => item.id)
        sessionStorage.setItem('chatListOrder', JSON.stringify(order))
      },

      // 点击单个聊天项
      customerItemClick(item, index) {
        const now = Date.now()
        //同步聊天数据，限制间隔3秒
        if (!item.lastActiveTime || now - item.lastActiveTime > 3000) {
          item.lastActiveTime = now
          if (!this.isLock) {
            this.getMsgList(item)
          }
          this.getLastReadIdData(item)
        }
        if (item.id === this.chatUserId) return
        this.chatShow = false //关闭聊天
        item.unreadList = [] //未读消息列表先清空
        this.chatUserId = item.id //用户ID 赋值
        this.msgList = item.history //数组直接赋值 修改magList 会进行引用传递
        this.chatUserInfo = item //用户信息赋值
        this.customerActiveIndex = index //选中客户index
        this.chatShow = true //展示聊天
        // 保存选中的会话ID到sessionStorage
        sessionStorage.setItem('selectedChatUserId', item.id)
        // 清除该用户的未读数量
        this.updateUnreadCount(item.id, 0)
        this.scrollToBottom();
      },

      // 打开聊天界面让滚动条始终出现在底部
      scrollToBottom() {
        if(!this.$refs.ChatMiddle) return
        this.$refs.ChatMiddle.scrollToBottom()
      },

      // 结束会话触发
      async emitChatCloseDialog() {
        const { success, data } = await apiCloseDialogAdmin({ id: this.chatUserId })
        if(!success) return
        this.$message.success(data.msg)
        // 清除该用户的未读数量
        this.updateUnreadCount(this.chatUserId, 0)
        this.chatList.splice(this.customerActiveIndex, 1)
        // 保存列表顺序
        this.saveChatListOrder()
        this.resetData()
      },

      // 转接客服成功
      emitTransferDelete() {
        // 清除该用户的未读数量
        this.updateUnreadCount(this.chatUserId, 0)
        this.chatList.splice(this.customerActiveIndex, 1)
        // 保存列表顺序
        this.saveChatListOrder()
        this.resetData()
      },

      // 加入黑名单成功触发
      emitAddblackSuccess(id) {
        let removeItem = this.chatList.find(item => {
          return item.id === id
        })
        // 清除该用户的未读数量
        this.updateUnreadCount(id, 0)
        this.chatList.splice(this.chatList.indexOf(removeItem), 1)
        // 保存列表顺序
        this.saveChatListOrder()
        this.resetData()
        // console.log('黑名单', id)
      },

      // 重置数据
      resetData() {
        this.chatShow = false
        this.chatUserId = null
        this.msgList = []
        this.chatUserInfo = {}
        this.customerActiveIndex = -1
        // 清除sessionStorage中保存的选中会话
        sessionStorage.removeItem('selectedChatUserId')
      },
    }
  }
</script>

<style lang="scss">
.v_chat {
  height: 100%;
  background: $chatContainerBg;
  // 左侧
  .v-chat-left {
    min-width: 268px;
    max-width: 290px;
    width: 30%;
    background: $white;
    // 头部
    .v-chat-left-head {
      min-height: 60px;
      padding: 0 10px;
      border-bottom: 1px solid $chatContainerBg;
      .v-chat-left-head-tab {
        flex: 1;
        height: 100%;
        .v-chat-left-head-tab-item {
          cursor: pointer;
          padding: 20px 10px;
          position: relative;
          span {
            font-size: $small-more-font-size;
            color: $fontColor;
          }
          &::before {
            position: absolute;
            bottom: 0px;
            left: 0;
            width: 100%;
            border-top: 2px solid #1880ff;
            border-radius: 4px 4px 0 0;
            transition: all 0.3s;
            content: '';
            pointer-events: none;
          }
        }
      }
    }
    // tab栏
    .v-chat-left-tab {
      padding: 0 20px;
      box-shadow: 0 2px 8px 0 #f4f6fb;
      position: relative;
      z-index: 1;
      .v-chat-left-tab-list {
        height: 44px;
        min-height: 44px;
        padding: 10px 0;
        .v-chat-left-tab-item {
          cursor: pointer;
          margin-right: 20px;
          font-size: $most-font-size;
          color: rgba(4, 15, 66, 0.3);
          &.active {
            color:  $fontColor;
          }
        }
      }
    }
    // 聊天列表
    .v-chat-left-list {
      flex: 1;
      overflow-y: auto;
      .v-chat-left-list-item {
        cursor: pointer;
        border-bottom: 1px solid $chatContainerBg;
        padding: 6px 10px;
        &.v-customer-active {
          background: #e6f5ff;
        }
        .v-item-left {
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            object-fit: cover;
            vertical-align: middle;
          }
          &.lixian {
            img {
             -webkit-filter: grayscale(100%);
            }
          }
          &.zaixian {
            img {
             -webkit-filter: none;
            }
          }
        }
        .v-item-right {
          padding-left: 10px;
          flex: 1;
          .v-item-right-top {
            flex: 1;
            .v-item-right-top-name {
              flex: 1;
              width: 160px;
              font-size: $small-font-size;
              color: rgba(4, 15, 66, 0.7);
              @include textEllipsis()
            }
            .v-item-right-top-time {
              color: rgba(4, 15, 66, 0.7);
              font-size: $small-font-size;
            }
          }
          .v-item-right-bottom {
            padding-top: 10px;
            .item-right-bottom-msg {
              flex: 1;
              @include textEllipsis();
              color: $fontColor;
              font-size: $small-more-font-size;
              width: 140px;
              max-height: 35px;
            }
            .item-right-bottom-msg-num {
              margin-left: 10px;
              width: 24px;
              height: 24px;
              background: #F74C31;
              border-radius: 50%;
              text-align: center;
              line-height: 24px;
              color: $white;
              font-size: $most-font-size;
            }
          }
        }
      }
    }
  }

  .v-chat-right-container {
    position: relative;
    flex: 1;
    height: 100%;
    // 无会话
    .s-no-chat-container {
      .s-no-chat {
        font-size: 160px;
      }
      p {
        color: $fontColor;
        font-size: $middle-font-size;
      }
      span {
        padding-top: 10px;
        color: rgba(4, 15, 66, 0.7);
        font-size: $small-more-font-size;
      }
    }

  }
}
</style>